import { BUSINESS_NAME } from "@/content";

export type ParallaxContent = {
  title: string;
  subTitle: string;
  overline: string;
  imageUrl: string;
  buttonCTA: string;
  tint: string;
  align: "left" | "right" | "center";
  buttonLink?: string;
};

export const parallaxContent1: ParallaxContent = {
  title: "Sydney security services for homes, sites and businesses",
  subTitle:
    "Ozy Wide Group supplies CCTV, alarms, intercoms, access control, automatic gates, guards, mobile patrols and security advice across Sydney.",
  overline: BUSINESS_NAME,
  imageUrl: "/images/parallax/pllx-1.webp",
  buttonCTA: "Get a security quote",
  align: "left",
  tint: "rgba(0, 0, 0, 0.1)",
};

export const parallaxContent2: ParallaxContent = {
  title: "Security systems and people planned around the site",
  subTitle:
    "From camera coverage and access points to patrol duties and incident reporting, Ozy Wide Group focuses on practical protection that can be used day to day.",
  overline: BUSINESS_NAME,
  imageUrl: "/images/parallax/pllx-2.webp",
  buttonCTA: "Secure your property",
  tint: "rgba(0, 0, 0, 0.28)",
  align: "right",
};
